import { Link } from "react-router-dom";
import { specials } from "@/mocks/specials";

export default function SpecialPreview() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
      {specials.map((special, index) => (
        <Link
          key={special.id}
          to={`/special/${special.id}`}
          className="group relative block aspect-[16/10] cursor-pointer overflow-hidden rounded-lg border border-background-800 animate-fade-up"
          style={{ animationDelay: `${index * 60}ms` }}
        >
          <img
            src={special.cover}
            alt={`${special.title} 专题封面`}
            title={`${special.title} 影视专题`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-background-950 via-background-950/50 to-transparent" />
          <div className="absolute inset-x-0 bottom-0 p-4">
            <h3 className="font-heading text-base font-600 text-foreground-50 transition-colors group-hover:text-accent-400">
              {special.title}
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-300">
              {special.subtitle}
            </p>
            <span className="mt-2 inline-flex items-center gap-1 text-xs text-secondary-300">
              {special.groups.reduce((acc, g) => acc + g.movieIds.length, 0)} 部作品
              <span className="flex h-3.5 w-3.5 items-center justify-center">
                <i className="ri-arrow-right-s-line" aria-hidden="true" />
              </span>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}